import { PSTFieldNames } from '@common/data-models/fields/pst-field-names';
import { createReducer, on } from '@ngrx/store';

import { TeamMembersActions } from './team-members.actions';
import { TeamMembersState } from './team-members.models';

export const initialTeamMembersState: TeamMembersState = {
    users: [],
    newUsers: [],
    security: [],
    loading: false,
    groupByField: PSTFieldNames.UserInfoStatus,
    sortByField: PSTFieldNames.UserInfoID,
    currentTabIndex: 0,
    currentGroup: '',
    currentPagePerGroup: {},
    selectedTeam: null,
    selectedRole: null,
    selectedStatus: null,
    searchTerm: null,
};

export const teamMembersReducer = createReducer(
    initialTeamMembersState,
    on(TeamMembersActions.loadTeamMembers, (state): TeamMembersState => {
        return { ...state, currentTabIndex: 0, currentGroup: '', currentPagePerGroup: {} };
    }),
    on(TeamMembersActions.loadTeamMembersSuccess, (state, { users, newUsers, security }): TeamMembersState => {
        return { ...state, users, newUsers, security };
    }),
    on(TeamMembersActions.setLoaderState, (state, { loading }): TeamMembersState => {
        return { ...state, loading };
    }),
    on(TeamMembersActions.setGroupByField, (state, { field }): TeamMembersState => {
        return { ...state, groupByField: field, currentTabIndex: 0, currentGroup: '', currentPagePerGroup: {} };
    }),
    on(TeamMembersActions.setSortByField, (state, { field }): TeamMembersState => {
        return { ...state, sortByField: field };
    }),
    on(TeamMembersActions.setTabIndex, (state, { index, group }): TeamMembersState => {
        return { ...state, currentTabIndex: index, currentGroup: group };
    }),
    on(TeamMembersActions.setCurrentGroup, (state, { group }): TeamMembersState => {
        return { ...state, currentGroup: group };
    }),
    on(TeamMembersActions.setCurrentPage, (state, { group, page }): TeamMembersState => {
        return { ...state, currentPagePerGroup: { ...state.currentPagePerGroup, [group]: page } };
    }),
    on(TeamMembersActions.deleteTeamMemberSuccess, (state, { user }): TeamMembersState => {
        return {
            ...state,
            users: state.users.filter(u => u.UserID !== user.UserID),
            newUsers: state.newUsers.filter(u => u.UserID !== user.UserID),
        };
    }),
    on(TeamMembersActions.updateTeamMemberSuccess, (state, { user }): TeamMembersState => {
        const users = state.users.map(u => (u.UserID === user.UserID ? user : u));
        const newUsers = state.newUsers.map(u => (u.UserID === user.UserID ? user : u));
        return { ...state, users, newUsers };
    }),
    on(TeamMembersActions.createTeamMemberSuccess, (state, { user }): TeamMembersState => {
        return { ...state, users: [...state.users, user], newUsers: state.newUsers };
    }),
    on(TeamMembersActions.filterTeamMembers, (state, { team, role, status, term }): TeamMembersState => {
        return {
            ...state,
            ...(team !== undefined && { selectedTeam: team }),
            ...(role !== undefined && { selectedRole: role }),
            ...(status !== undefined && { selectedStatus: status }),
            ...(term !== undefined && { searchTerm: term }),
        };
    })
);
